import {SidebarCollapseIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {use, useEffect, useRef} from 'react'

import styles from './SidebarPageLayout.module.css'
import {SidebarPageLayoutActionsContext, SidebarPageLayoutStateContext} from './state'

export type SidebarPageLayoutSidebarTriggerProps = {
  /** Accessible label for the trigger button. */
  'aria-label'?: string
  className?: string
}

export function SidebarTrigger({'aria-label': ariaLabel, className}: SidebarPageLayoutSidebarTriggerProps) {
  const {isDialogOpen, sidebarLabel} = use(SidebarPageLayoutStateContext)
  const actions = use(SidebarPageLayoutActionsContext)
  const triggerRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    actions?.setTriggerElement(triggerRef.current)
    return () => actions?.setTriggerElement(null)
  }, [actions])

  if (!actions) return null

  // Default to "Open <sidebar aria-label>" when the sidebar publishes one,
  // falling back to "Open sidebar".
  const label = ariaLabel ?? (sidebarLabel ? `Open ${sidebarLabel}` : 'Open sidebar')

  return (
    <IconButton
      ref={triggerRef}
      className={[styles.SidebarTrigger, className].filter(Boolean).join(' ')}
      icon={SidebarCollapseIcon}
      aria-label={label}
      aria-haspopup="dialog"
      aria-expanded={isDialogOpen}
      variant="invisible"
      onClick={actions.openDialog}
    />
  )
}

SidebarTrigger.displayName = 'SidebarPageLayout.SidebarTrigger'
